/** PORTFOLIOS — one client's portfolios, fetched by user id. Client 360°'s Portfolio tab. */
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { GET_PORTFOLIOS } from '../queries';
import { EMPTY, byDesc } from './_shared';

/**
 * Every portfolio a client owns, scoped to that user rather than sliced out of
 * the book-wide roll-up — `goalId` only comes back populated when
 * `getPortfolios` is asked for one user at a time (see useGoalPortfolios).
 */
export function usePortfolios(clientUserId) {
  const { data, loading, error } = useQuery(GET_PORTFOLIOS, {
    variables: { userId: clientUserId ? String(clientUserId) : null, allUsers: false, limit: 200 },
    skip: !clientUserId,
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
  });

  return useMemo(() => {
    const rows = [...(data?.getPortfolios?.portfolios ?? EMPTY)].sort(byDesc((p) => p.marketData?.marketValue));
    return { loading, error, rows };
  }, [data, loading, error]);
}
